'use strict';

var $ = require('jquery');
var Marionette = require('backbone.marionette');

var polyglot = require('../../utilities/polyglot').default;

export default Marionette.View.extend({

  className: 'attendee-list-item',

  template: require('./templates/attendee.hbs'),

  events: {
    'click .delete': 'onDelete',
  },

  triggers: {
    'click .edit': 'click:edit-attendee',
  },

  initialize: function (options) {
    this.appointment = options.appointment;
    this.client = options.client;
    this.clients = options.clients;
  },

  serializeData: function () {
    return {
      client: this.client.attributes,
    };
  },

  onDelete: function() {
    const name = `${this.client.get('first_name')} ${this.client.get('last_name')}`;

    if (confirm(polyglot.t('forms.attendees.remove_warning', { name }))) {
      $('.add-attendee').prop('disabled', false);
      this.clients.remove(this.client);
      this.remove();
    }
  },
});
